// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"299":"b7cf09fd","373":"459ffd7d","384":"072f25ad","436":"33f2ea4d","472":"71d92a94","799":"33fa42d9","823":"1cd76be9","831":"cc9ae54f","851":"8e2143cf"}[chunkId] + ".chunk.js";
};